import type { MailContentProps, MailMetadata } from "../../lib/types";
import { MailSignature } from "../mail/mail-signature";

function AchatChaudiere({ variablesData }: MailContentProps) {
  return (
    <div className="space-y-2">
      <p>
        Bonjour {variablesData.genre_masc_abrege}{" "}
        {variablesData.responsable_grand_est_precedent_nom},{" "}
      </p>
      <p>
        Je tenais à vous informer que l'achat immédiat d'une nouvelle chaudière
        pour le bâtiment industriel s'impose. Deux pannes sérieuses le mois
        dernier ont provoqué des réparations de fortune. Je décline toute
        responsabilité si le changement d'équipement n'a pas lieu rapidement.
      </p>
      <p>
        A la suite de différents appels d'offres, j'estime qu'un équipement
        satisfaisant peut-être obtenu pour 53 200 euros HT, travaux compris.
      </p>
      <p>Cordialement,</p>
      <MailSignature
        emetteurLogo={AchatChaudiere.metadata.emetteurLogo}
        emetteur={AchatChaudiere.metadata.emetteur}
        emetteurPoste={AchatChaudiere.metadata.emetteurPoste}
        emetteurEntreprise={AchatChaudiere.metadata.emetteurEntreprise}
      />
    </div>
  );
}

AchatChaudiere.metadata = {
  titre: "Achat Chaudière",
  cleMail: "achat_chaudiere",
  messageTransfert: false,
  emetteur: "Michel PAX",
  emetteurPoste: "Responsable Entretien/Sécurité",
  emetteurEntreprise: "SYTEL Grand Est",
  emetteurLogo: "/logos/sytel_grand_est.png",
  dateRelative: -2,
  piecesJointes: [],
} as MailMetadata;

export default AchatChaudiere;
